import Box from "@mui/material/Box";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// components
import Icon from "../../Components/Icon";

interface Props {
  time: number;
  onChange: (time: string) => void;
  disabled: boolean;
}

const UITimePicker = (props: Props) => {
  const { time, onChange, disabled } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: "4px",
          paddingRight: 0,
        }}
      >
        <TimePicker
          disabled={disabled}
          value={new Date(time)}
          onChange={(newValue: any) => {
            const newTime = new Date(newValue);
            onChange(newTime.toString());
          }}
          sx={{
            "& .MuiInputBase-input": {
              padding: "8px 0 8px 12px",
              color: "#7E8392",
              fontWeight: 400,
              fontSize: "14px",
            },
            "& .MuiSvgIcon-root": {
              fill: "#7E8392",
              fontSize: "1.2rem",
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};
export default UITimePicker;
